import { useCallback } from "react";
import { atom } from "recoil";
import { useRecoilState } from "recoil";

const ACCOUNT_SETTING_EDITING_DEFAULT = {
  editing: false,
  operation: '',
};

const accountSettingEditingState = atom({
  key: 'accountSettingEditingState',
  default: ACCOUNT_SETTING_EDITING_DEFAULT
});

export const useAccountSettingEditing = () => {
  const [accountSettingEditing, setAccountSettingEditing] = useRecoilState(accountSettingEditingState);

  //編集開始(編集中状態(state)を設定)
  const startEditing = useCallback((operation) => {
    setAccountSettingEditing({editing: true, operation});
  }, [setAccountSettingEditing]);

  //編集終了(編集中状態(state)をクリア)
  const endEditing = useCallback(() => {
    setAccountSettingEditing(ACCOUNT_SETTING_EDITING_DEFAULT);
  }, [setAccountSettingEditing]);

  return {
    accountSettingEditing,
    startEditing,
    endEditing,
  }
};

export const accountSettingOperation = {
  AIRPORT_GROUP_SETTING: 'Airport Group',
};
